var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar',{ref:"navbar"}),_c('Sidebar',{ref:"sidebar"}),_c('div',{staticClass:"content"},[(_vm.loading)?_c('loading'):_c('Content',{on:{"sidebar":function($event){return _vm.closeSidebar()}}})],1),_c('Footer',{ref:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }